import { Toast, Dialog,Field, CellGroup } from 'vant';
import wx from 'jweixin-1.6.0';
import comment from "../../util/comment"

var that;
var timer;
export default {
    setup() {
        const onClickLeft = () => history.back();
        return {
            onClickLeft,
        };
    },
    data() {
        return {
            dhInfoList: [],
            test:"0",
            user:{},
            content:""
        };
    },

    created() {
        that = this;

    },
    
    beforeDestroy() {
        if (this.timer) {
            clearInterval(this.timer); //关闭
        } //利用vue的生命周期函数
    },

    methods: {
        question() {
            var question = document.getElementById("myText").value;
            console.log("question", question);
            var answer = document.getElementById("myAns").value;
            this.$api.deepseekAns({
                params: {
                    question: question,
                },
                success: function (res) {
                    console.log("answer", res.data);
                    that.content = res.data;
                }
            })
        }
    }
};
